/**
 * sl-n8i1.5: Automation UI Gating Constants
 * sl-y2po.12: useWorkflowGate hook removed — plan+connectivity gate moved to WorkflowGateProvider
 *
 * This file retains only the CSS class constant for the Lit<->React bridge.
 * The body class is toggled by WorkflowGateProvider.
 */

/**
 * CSS class name added to body when automation is plan-allowed AND configured.
 * Used by Lit components to check automation state via MutationObserver.
 */
export const WORKFLOW_ENABLED_CLASS = 'workflow-enabled';
